/**
 * @license lucide v0.356.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const BookAudio = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20" }],
    ["path", { d: "M8 8v3" }],
    ["path", { d: "M12 6v7" }],
    ["path", { d: "M16 8v3" }]
  ]
];

export { BookAudio as default };
//# sourceMappingURL=book-audio.js.map
